<template>
  <q-btn
    class="full-width q-py-sm"
    :class="{ 'bg-secondary': isActive }"
    align="left"
    :to="to"
    v-bind="$attrs"
    flat
    no-caps
  >
    <div class="on-right text-left">
      <div>{{ label }}</div>
      <div class="text-grey-7">
        {{ description }}
      </div>
    </div>
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    exact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive(): boolean {
      return this.$route.path.startsWith(this.to) && !this.exact;
    },
  },
});
</script>
